// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1HhoS","column":"style_column__1Ls4Y","row":"style_row__2XiOk"};